<template>
    
</template>

<script>
    export default {
        name: "Error"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Error.vue